import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const haptic = (style = "light") => {
  try { window.webkit?.messageHandlers?.haptic?.postMessage?.(style); } catch {}
  try { navigator.vibrate?.(style === "success" ? [10, 30, 10] : 10); } catch {}
};

export const shareOrCopy = async ({ title, text, url }) => {
  haptic();
  if (navigator.share) {
    try { await navigator.share({ title, text, url }); } catch {}
    return "native";
  }
  try { await navigator.clipboard.writeText(`${text} ${url}`); return "copied"; } catch {}
  try {
    const ta = document.createElement("textarea");
    ta.value = `${text} ${url}`;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok ? "copied" : "failed";
  } catch { return "failed"; }
};

export const isNativeApp = () =>
  typeof window !== "undefined" &&
  (!!window.webkit?.messageHandlers ||
    window.navigator.standalone === true ||
    window.matchMedia?.("(display-mode: standalone)").matches);
